const SummaryPageAnalyticsContext = { page: 'summary_page' };

export default SummaryPageAnalyticsContext;
